import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

import Draggable from 'react-draggable';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AddTimeDialogContent from './AddTimeDialogContent';
import timesheetService from '../../../services/TimesheetService';

import { toast } from 'react-hot-toast';
import {
  getFormattedTableRows,
  isLeaveTimesheetFormDataValid,
  isTimesheetDateInFuture,
  isTimesheetFormDataValid,
  upsertTimesheetRow
} from '../table/helpers';
import { checkLeaveCategory, isLeaveHoursValid } from './helper';
import DateCheckDialog from '../dateCheckDialog/DateCheckDialog';

export default function AddTimeDialog({
  open,
  setOpen,
  handleClose,
  customerRefList,
  classRefList,
  setRows,
  takeLeaveOption,
  requestLeaveOption,
  myTimeFormData,
  setMyTimeFormData,
  timesheetSavingOptions,
  setTimesheetSavingOptions,
  setAnchorEl,
  showLeaveBalance,
  setShowLeaveBalance,
  sickLeaveBalance,
  setSickLeaveBalance
}) {
  const [todayDate, setTodayDate] = useState();
  const [proceedFutureDate, setProceedFutureDate] = useState(false);
  const [dateCheckDialogOpen, setDateCheckDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const nodeRef = useRef(null);

  useEffect(() => {
    let todayDate = format(new Date(), 'yyyy-MM-dd');
    setTodayDate(todayDate);
  }, []);

  //once My Time save as draft button is clicked
  const handleTimesheetAdd = (e) => {
    e.preventDefault();
    const timesheetPayload = isTimesheetFormDataValid(myTimeFormData);
    if (!timesheetPayload) {
      return toast.error('Please fill out all the mandatory data');
    }

    let timesheetDateCheck = false;

    if (!proceedFutureDate) {
      //check if the timesheet date entered today or not, should  proceed future date
      timesheetDateCheck = isTimesheetDateInFuture(myTimeFormData.date);
    }

    //popup  a dialog
    if (timesheetDateCheck && !proceedFutureDate) {
      setDateCheckDialogOpen(true);
    }

    if (!timesheetDateCheck || proceedFutureDate) {
      // eslint-disable-next-line no-undef
      const formData = new FormData();

      formData.append('timesheetPayload', JSON.stringify(timesheetPayload));
      // eslint-disable-next-line no-undef
      const userId = localStorage.getItem('userId');
      formData.append('userId', userId);

      if (myTimeFormData.timeSheetImageUrl && myTimeFormData.timeSheetImageUrl.length > 0) {
        if (myTimeFormData.timeSheetImageUrl.length > 5) {
          return toast.error('You can upload a maximum of 5 images');
        }
        for (let i = 0; i < myTimeFormData.timeSheetImageUrl.length; i++) {
          formData.append('files', myTimeFormData.timeSheetImageUrl[i]);
        }
      }

      setLoading(true);
      timesheetService
        .addTimesheet(formData)
        .then(({ data }) => {
          toast.success('Successfully added timesheet');
          let timesheetData = [];
          timesheetData.push(data.data);
          const formattedTimesheet = getFormattedTableRows(timesheetData);
          setRows((currentRows) => upsertTimesheetRow(currentRows, formattedTimesheet[0]));
          setMyTimeFormData({
            // eslint-disable-next-line no-undef
            startTime: localStorage.getItem('startTime') || '07:00',
            // eslint-disable-next-line no-undef
            finishTime: localStorage.getItem('finishTime') || '15:00',
            hour: 8,
            date: todayDate,
            client: '',
            task: '',
            isBillable: false,
            description: '',
            variationNote: '',
            workType: '',
            medicalStatus: false,
            timeSheetImageUrl: ''
          });
          setOpen(false);
          setProceedFutureDate(false);
        })
        .catch((error) => {
          // eslint-disable-next-line no-console, no-undef
          console.log('error is:', error);
          toast.error(
            error?.response?.data?.error ||
              error?.response?.data?.data?.message ||
              error?.response?.data?.message ||
              'Could not add and submit timesheet'
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  //once My Leave save as draft button is clicked
  const handleLeaveTimesheetAdd = (e) => {
    e.preventDefault();
    const timesheetPayload = isLeaveTimesheetFormDataValid(myTimeFormData);

    if (!timesheetPayload) {
      return toast.error('Please fill out all the mandatory data');
    }

    if (checkLeaveCategory(myTimeFormData.workType)) {
      if (!isLeaveHoursValid(showLeaveBalance, myTimeFormData.hour)) {
        return toast.error(`Not enough leave balance to take ${myTimeFormData.workType}`);
      }
    }

    if (myTimeFormData.workType === "Personal/Carer's Leave") {
      if (!isLeaveHoursValid(sickLeaveBalance, myTimeFormData.hour)) {
        return toast.error(`Not enough leave balance to take ${myTimeFormData.workType}`);
      }
    }

    // eslint-disable-next-line no-undef
    const formData = new FormData();
    formData.append('timesheetPayload', JSON.stringify(timesheetPayload));
    // eslint-disable-next-line no-undef
    const userId = localStorage.getItem('userId');
    formData.append('userId', userId);

    if (myTimeFormData.timeSheetImageUrl && myTimeFormData.timeSheetImageUrl.length > 0) {
      if (myTimeFormData.timeSheetImageUrl.length > 5) {
        return toast.error('You can upload a maximum of 5 images');
      }
      for (let i = 0; i < myTimeFormData.timeSheetImageUrl.length; i++) {
        formData.append('files', myTimeFormData.timeSheetImageUrl[i]);
      }
    }

    setLoading(true);
    timesheetService
      .addTimesheet(formData)
      .then(({ data }) => {
        toast.success('Successfully added timesheet');
        let timesheetData = [];
        timesheetData.push(data.data);
        const formattedTimesheet = getFormattedTableRows(timesheetData);
        setRows((currentRows) => upsertTimesheetRow(currentRows, formattedTimesheet[0]));
        setMyTimeFormData({
          // eslint-disable-next-line no-undef
          startTime: localStorage.getItem('startTime') || '07:00',
          // eslint-disable-next-line no-undef
          finishTime: localStorage.getItem('finishTime') || '15:00',
          hour: 8,
          date: todayDate,
          client: '',
          task: '',
          isBillable: false,
          description: '',
          variationNote: '',
          workType: '',
          medicalStatus: false,
          timeSheetImageUrl: ''
        });
        setOpen(false);
        setAnchorEl(false);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console, no-undef
        console.log('error is:', error);
        toast.error(error?.response?.data?.error || 'Could not add leave form.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <Draggable nodeRef={nodeRef}>
        <Dialog open={open} ref={nodeRef} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">
            {takeLeaveOption && !requestLeaveOption
              ? 'My Leave'
              : !takeLeaveOption && !requestLeaveOption
              ? 'My Time'
              : 'My Leave Request'}
          </DialogTitle>
          <DialogContent>
            <AddTimeDialogContent
              myTimeFormData={myTimeFormData}
              setMyTimeFormData={setMyTimeFormData}
              customerRefList={customerRefList}
              classRefList={classRefList}
              handleTimesheetAdd={handleTimesheetAdd}
              handleClose={handleClose}
              takeLeaveOption={takeLeaveOption}
              handleLeaveTimesheetAdd={handleLeaveTimesheetAdd}
              timesheetSavingOptions={timesheetSavingOptions}
              setTimesheetSavingOptions={setTimesheetSavingOptions}
              setRows={setRows}
              setOpen={setOpen}
              showLeaveBalance={showLeaveBalance}
              setShowLeaveBalance={setShowLeaveBalance}
              sickLeaveBalance={sickLeaveBalance}
              setSickLeaveBalance={setSickLeaveBalance}
              setProceedFutureDate={setProceedFutureDate}
              setDateCheckDialogOpen={setDateCheckDialogOpen}
              proceedFutureDate={proceedFutureDate}
              loading={loading}
              setLoading={setLoading}
            />
          </DialogContent>
          <DialogActions></DialogActions>
          {dateCheckDialogOpen && (
            <DateCheckDialog
              setProceedFutureDate={setProceedFutureDate}
              date={myTimeFormData.date}
              setDateCheckDialogOpen={setDateCheckDialogOpen}
              dateCheckDialogOpen={dateCheckDialogOpen}
            />
          )}
        </Dialog>
      </Draggable>
    </div>
  );
}

AddTimeDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  customerRefList: PropTypes.array,
  classRefList: PropTypes.array,
  setRows: PropTypes.func,
  takeLeaveOption: PropTypes.bool,
  setOpen: PropTypes.func,
  myTimeFormData: PropTypes.shape({
    startTime: PropTypes.string,
    finishTime: PropTypes.string,
    hour: PropTypes.any,
    date: PropTypes.any,
    client: PropTypes.any,
    task: PropTypes.any,
    workType: PropTypes.string,
    isBillable: PropTypes.bool,
    description: PropTypes.string,
    variationNote: PropTypes.string,
    medicalStatus: PropTypes.bool,
    timeSheetImageUrl: PropTypes.any
  }),
  setMyTimeFormData: PropTypes.func,
  timesheetSavingOptions: PropTypes.array,
  setTimesheetSavingOptions: PropTypes.func,
  setAnchorEl: PropTypes.func,
  showLeaveBalance: PropTypes.number,
  setShowLeaveBalance: PropTypes.func,
  sickLeaveBalance: PropTypes.number,
  setSickLeaveBalance: PropTypes.func,
  requestLeaveOption: PropTypes.any
};
